export const DEFAULT_LIMIT_VALUE = 12000;
